import { Image, Text } from "@fluentui/react-northstar";

import { Grid } from "@mui/material";
import React from "react";

function StudentCard({
  student,
  userSvg,
  props,
  isMobileView,
  setSelectedStudent,
}) {
  return (
    <Grid
      item
      xs={isMobileView ? 5 : 3}
      key={student.StudentEmailID + "-grid-item"}
      style={{
        cursor: "pointer",
        boxShadow:
          " 0 1px 2px 0 rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%)",
        borderRadius: "8px",
        margin: "10px",
        alignSelf: "stretch",
        paddingLeft: 0,
      }}
      className="seg"
      onClick={() =>
        setSelectedStudent({
          header: student?.StudentName || student.StudentEmailID.split("@")[0],
          image: student?.studPhoto?.Foto
            ? student.studPhoto.Foto + props.user.SASToken
            : userSvg,
          content: student,
          key: student.StudentEmailID,
        })
      }
      title={student.StudentEmailID}
    >
      <Image
        src={
          student.studPhoto.Foto
            ? student.studPhoto.Foto + props.user.SASToken
            : userSvg
        }
        style={{
          // borderRadius: "6px",
          // width: "100%",
          // height: "70px",
          // margin: "10px 0px 0px",
          borderRadius: "6px",
          width: "80%",
          height: "72%",
          margin: "3px 12px 0px",
        }}
      />
      <Text
        content={student.StudentName}
        className="Karla fw6 m1 tcap"
        style={{
          margin: "10px 0px 0",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      />
    </Grid>
  );
}

export default StudentCard;
